// Hungarian phone normalizer: accepts +36…, 0036…, 06…, or bare 30/20/70/31/50 number;
// returns +36<9 digits> on success, throws otherwise.
const HU_PREFIXES = ['20', '30', '31', '50', '70', '1'];

export function normalizeHungarianPhone(input: string): string {
  const digits = input.replace(/[\s\-()/.]/g, '');
  let rest: string;
  if (digits.startsWith('+36')) rest = digits.slice(3);
  else if (digits.startsWith('0036')) rest = digits.slice(4);
  else if (digits.startsWith('06')) rest = digits.slice(2);
  else if (/^\d+$/.test(digits)) rest = digits;
  else throw new Error('Invalid phone format');

  if (!/^\d+$/.test(rest)) throw new Error('Invalid phone format');

  // rest must start with one of the HU prefixes; total length after prefix strip is 8 or 9.
  const matchedPrefix = HU_PREFIXES.find((p) => rest.startsWith(p));
  if (!matchedPrefix) throw new Error('Not a Hungarian number');

  // Mobile numbers (20/30/31/50/70): 9 digits total after "+36".
  // Budapest landline (1): 8 digits total.
  const expected = matchedPrefix === '1' ? 8 : 9;
  if (rest.length !== expected) throw new Error('Wrong number of digits');

  return `+36${rest}`;
}
